/***********************************************************************************************
 * 사투리 지역 영상 화면 컴포넌트
 *
 * CopyRight (c) 2023 박주형
 **********************************************************************************************/
import {Component, HostBinding, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Subscription} from "rxjs";

import {CITY2, CITY2_DEFAULT, GetRegionByName, GetRegionName, isCity2, REGION} from "../../shared/defines/gukeo.const";
import {SearchParam} from "../../shared/defines/client.const";


@Component({
  selector: 'app-dialect-region',
  templateUrl: './dialect-region.component.html',
  styleUrls: ['./dialect-region.component.scss']
})
export class DialectRegionComponent implements OnDestroy {
  @HostBinding('class') class = 'all-menu-group-list flex-grow';
  @HostBinding('style.display') styleBlock = 'block';

  protected selectedCity: CITY2 = CITY2_DEFAULT;  // 선택 지역

  private queryParams$?: Subscription;
  private route$?: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {

    /******************************************************************************************
     * 주소 뒤의 파라미터를 받아오는 곳.
     * 입력된 파라미터가 없어도 처음 초기화 할 때에도 불려진다.
     * router.navigate()로 같은 주소를 호출하면 이 코드가 다시 불려진다.
     */
    this.queryParams$ = this.route.queryParams
      .subscribe(params => {
        console.log('DialectRegionComponent::constructor() queryParams =', params);

        if ('city' in params) {
          const city2: CITY2 = params['city'];
          if (!isCity2(city2)) {
            console.error('DialectRegionComponent::constructor() invalid city =', params['city']);
            this.selectedCity = CITY2_DEFAULT;
          }
          else {
            this.selectedCity = city2;
          }
        }
        else {
          this.selectedCity = CITY2_DEFAULT;
        }
      });

    /******************************************************************************************
     * 라우터 파라미터를 읽어오는 곳
     * 처음 이 페이지에 들어올 때 불려진다.
     * url이 변경되어도 불린다.
     * queryParams가 바뀐 것(주소뒤의 파리미터가 변경된 경우)으로는 여기가 불려지지 않는다.
     */
    this.route$ = route.params.subscribe(params => {
      console.log('DalectListComponent::::constructor() params = ', params);

    });
  }

  ngOnDestroy() {
    this.queryParams$?.unsubscribe();
    this.route$?.unsubscribe();
  }

  onChangeCity(city2: CITY2) {
    console.log('DialectRegionComponent.onChangeCity()', city2);

    if (city2 === CITY2_DEFAULT) {
      this.router.navigate(['/dialect', 'region']).then();
    }
    else {
      if (!isCity2(city2)) {
        throw new Error('DialectMenuComponent.onChangeRegion() invalid city = ' + city2);
      }

      const queryParams: SearchParam = {
        city: city2,
      };
      this.router.navigate(['/dialect', 'region'], { queryParams }).then();
    }
  }
}
